export const DefaultRpcs = [
    { uri: 'https://api.steemit.com', testnet: false },
    { uri: 'https://api.steemitdev.com', testnet: false },
    { uri: 'https://api.upvu.org', testnet: false },
    { uri: 'https://api.justyy.com', testnet: false },
    { uri: 'https://steemd.steemworld.org', testnet: false },
    { uri: 'https://api.steem.fans', testnet: false },
    { uri: 'https://api.dlike.io', testnet: false },
    { uri: 'https://steemapi.boylikegirl.club', testnet: false },
    { uri: 'https://api.steemwow.com', testnet: false },
    { uri: 'https://api.steem-fanbase.com', testnet: false },
    { uri: 'https://api.pennsif.net', testnet: false },
    { uri: 'https://api.steemzzang.com', testnet: false },
];
